import { render, staticRenderFns } from "./support-article-product-links.vue?vue&type=template&id=a1cf293c&"
import script from "./support-article-product-links.vue?vue&type=script&lang=js&"
export * from "./support-article-product-links.vue?vue&type=script&lang=js&"
import style0 from "./support-article-product-links.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default})
